import React from 'react';

import { useAttributeDefinitionPrioritizedDataSource } from '@neptune/shared/attributes-business-logic';
import { regexpSearchFilter } from '@neptune/shared/search-business-logic';

import { AttributeDefinition, convertAttributeToSearchString } from 'domain/experiment/attribute';

export const usePrefillDataSource = (
  prefillAttributes: AttributeDefinition[],
): ReturnType<typeof useAttributeDefinitionPrioritizedDataSource> => {
  return React.useCallback(
    async (search: string) => {
      const prefillAttributesResult = regexpSearchFilter(
        search,
        prefillAttributes,
        convertAttributeToSearchString,
      );

      return {
        entries: prefillAttributesResult,
        thereIsMore: false,
        priorityMatches: new Map(prefillAttributes.map((attribute) => [attribute.name, true])),
      };
    },
    [prefillAttributes],
  );
};
